export const PATH = {
  RENTAL_DAYS: 'dashboard/carRentalDaysByMonth',
  FUTURE_BOOKING: 'dashboard/futureBookings',
  REVENUE_PER_DAY: 'dashboard/revenuePerDay',
  REVENUE_PER_UNIT: 'dashboard/revenuePerUnit',
  VOLUMES: 'dashboard/volumes',
  REVENUE: 'dashboard/revenue',
  RESERVATION_SCHEDULE: 'dashboard/reservationSchedule',
  REVENUE_PER_CAR_CLASS: 'dashboard/revenuePerCarCategory',
  REVENUE_PER_CAR: 'dashboard/revenuePerCar',
}
